// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Expand = function Expand(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M14.83 1.167v3.72l-.99-.99-3.28 3.27-1.72-1.72 3.27-3.28-.99-.99v-.01h3.71zM3.89 13.837l.99.99v.01H1.17v-3.73l.99 1 3.29-3.29 1.73 1.73-3.29 3.29zM14.83 11.117v3.72h-3.72l1-1-3.28-3.29 1.73-1.72 3.28 3.28.99-.99zM7.19 5.437l-1.73 1.73-3.29-3.28-1 1v-3.72h3.72l-.99.99 3.29 3.28z"
    }))
  );
};

export default Expand;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Expand.js
// module id = 1004
// module chunks = 0